import { Avatar, Tooltip, Typography } from '@aloft/toolkit-sui';
// TODO: figure out typing for MenuItem `as`
// eslint-disable-next-line
import { Menu, MenuButton, MenuItem, MenuList } from '@aloft/toolkit-sui/chakra';
import { useAuth0 } from '@auth0/auth0-react';

import { useModuleContext } from '../../modules/shared/moduleContext/useModuleContext.ts';
import { selectFullNameWithDefault } from '../../redux/features/selectors/accountSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { EnvironmentFilter } from '../EnvironmentFilter/EnvironmentFilter.tsx';
import { menuListProps, menuProps } from './consts.ts';

export const MainHeaderProfileMenu = () => {
  const {
    navigation: { Link },
  } = useModuleContext();

  const { logout } = useAuth0();

  const userFullName = useAppSelector((state) => selectFullNameWithDefault(state, 'Appraiser'));
  const isAdmin = useAppSelector((state) => state.account.isAdmin);
  const impersonationUserId = localStorage.getItem('impersonation-user-id');

  return (
    <Menu {...menuProps} id="nav-menu" data-testid="nav-menu">
      <Tooltip label="Profile">
        <MenuButton
          data-testid="profile-menu-button"
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Avatar name={userFullName} variant={'outline'} size="accountAvatar" />
        </MenuButton>
      </Tooltip>
      <MenuList {...menuListProps}>
        <EnvironmentFilter environments={['regularMode']}>
          <MenuItem paddingX={8} as={Link} to="/account">
            <Typography variant="body1">Profile</Typography>
          </MenuItem>
        </EnvironmentFilter>
        <MenuItem paddingX={8} as={Link} to={'/orders'}>
          <Typography variant="body1">My Orders</Typography>
        </MenuItem>
        {(isAdmin && !impersonationUserId) && (
          <MenuItem paddingX={8} as={Link} to="/admin" data-testid="admin-button">
            <Typography variant="body1" color="surfaceAccent1">Admin</Typography>
          </MenuItem>
        )}
        <MenuItem paddingX={8} onClick={() => logout()} data-testid="logout-button">
          <Typography variant="body1">Logout</Typography>
        </MenuItem>
      </MenuList>
    </Menu>
  );
};
